import { initializeFeatureFlags } from '@chargeafter/feature-flag';
import { tracker } from './trackerManager';
import logger from './loggerManager';
import { environment } from '../environment';

export const useInitFeatureFlags = () => {
  const { envName, featureFlagsBaseUrl, featureFlagsKey } = environment;

  return async (merchantId: string, merchantPublicKey: string) => {
    const config = {
      kind: 'multi',
      merchant: { key: merchantPublicKey, merchantId },
      environment: { key: envName },
    };

    const flags = await initializeFeatureFlags(config, {
      url: featureFlagsBaseUrl ?? '',
      sdkKey: featureFlagsKey ?? '',
    });

    const featureFlagsTurnedOn = Object.keys(flags).reduce(
      (curr, next) =>
        flags[next] ? { ...curr, [`ff_${next}`]: flags[next] } : curr,
      {},
    );

    const eventData = {
      config,
      featureFlagsTurnedOn,
    };

    tracker.event({ eventName: 'ff_set', ...eventData });
    logger.log('Feature flags initialized', {
      filename: 'featureFlagsManager.ts',
      function: 'useInitFeatureFlags',
      eventData,
    });
  };
};
